import React from 'react';
import { Button } from '../common';

export default function AppointmentDeleteModal({
  isOpen,
  appointment,
  isDeleting,
  seriesDeleteMode,
  onSeriesDeleteModeChange,
  onConfirm,
  onCancel,
  t,
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-60">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">{t.deleteAppointment}</h3>
        <p className="text-gray-600 mb-4">
          {t.deleteAppointmentConfirm}
        </p>

        {appointment?.is_recurring && (
          <div className="mb-6 p-4 bg-gray-50 rounded-lg">
            <label className="block text-sm font-medium text-gray-700 mb-3">
              איזה תורים למחוק?
            </label>
            <div className="space-y-2">
              <label className="flex items-center space-x-3 rtl:space-x-reverse">
                <input
                  type="radio"
                  name="seriesDeleteMode"
                  value="single"
                  checked={seriesDeleteMode === 'single'}
                  onChange={(e) => onSeriesDeleteModeChange(e.target.value)}
                  className="w-4 h-4 text-red-600 border-gray-300 focus:ring-red-500"
                />
                <span className="text-sm text-gray-700">רק התור הזה</span>
              </label>
              <label className="flex items-center space-x-3 rtl:space-x-reverse">
                <input
                  type="radio"
                  name="seriesDeleteMode"
                  value="future"
                  checked={seriesDeleteMode === 'future'}
                  onChange={(e) => onSeriesDeleteModeChange(e.target.value)}
                  className="w-4 h-4 text-red-600 border-gray-300 focus:ring-red-500"
                />
                <span className="text-sm text-gray-700">התור הזה ועתידיים</span>
              </label>
              <label className="flex items-center space-x-3 rtl:space-x-reverse">
                <input
                  type="radio"
                  name="seriesDeleteMode"
                  value="all"
                  checked={seriesDeleteMode === 'all'}
                  onChange={(e) => onSeriesDeleteModeChange(e.target.value)}
                  className="w-4 h-4 text-red-600 border-gray-300 focus:ring-red-500"
                />
                <span className="text-sm text-gray-700">כל התורים בסדרה</span>
              </label>
            </div>

            {(seriesDeleteMode === 'future' || seriesDeleteMode === 'all') && (
              <div className="mt-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                <div className="flex items-start space-x-2">
                  <svg className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                  </svg>
                  <div className="flex-1">
                    <p className="text-sm font-medium text-blue-800">שים לב:</p>
                    <p className="text-sm text-blue-700 mt-1">
                      תורים ששולמו (עם חשבונית או תשלום שהושלם) לא יימחקו, גם אם הם חלק מהסדרה החוזרת. רק תורים שטרם שולמו יימחקו.
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        <div className="flex space-x-3 justify-end">
          <Button variant="secondary" onClick={onCancel}>
            {t.cancel}
          </Button>
          <Button variant="danger" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? t.deleting : t.delete}
          </Button>
        </div>
      </div>
    </div>
  );
}
